import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function userService() {
  const api = () => useApi()

  function getUser(id) {
    return api().query(`${URLS.users}${id}/`)
  }

  function patchProfile(id, data) {
    return api().mutation(`${URLS.profile}${id}/`, 'PATCH', data)
  }

  return {
    getUser,
    patchProfile,
  }
}
